/* ---------------------------------------------------------------------------
   TRIAL PRODUCT CART RULES  ("Try ALP – 1 Can")
   ---------------------------------------------------------------------------
   Cart rules for the trial product, live inside the AJAX cart drawer:

     RULE 1 (dependency): *** CURRENTLY DISABLED *** — the trial CAN now be
             ordered on its own, without any other product in the cart.
             (Originally: the trial could only be in the cart alongside another
             product and was auto-removed if left alone. See the commented-out
             block in enforce() for how to re-enable it.)

     RULE 2 (single item): ACTIVE — at most ONE trial line, quantity 1. Adding a
             second flavour (or raising the quantity above 1) is rolled back to
             the first flavour at qty 1, and a message is shown.

   The trial variants are identified by their shared SKU prefix (all 8 flavours
   use "TRIAL-"). A product-handle fallback is also supported.

   To change the target product, edit CONFIG below. No other edits needed.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  var CONFIG = {
    // All trial variants share this SKU prefix (case-insensitive). Primary match.
    skuPrefix: "TRIAL-",
    // Optional fallback: product handle(s) that count as the trial product.
    handles: [
      "try-alp-1-can",
    ],
    // Messages shown to the shopper.
    messageNeedsOther:
      "Try ALP can only be ordered together with another product, so it was removed from your cart.",
    messageOnlyOne:
      "You can only add one Try ALP — a single flavour, quantity 1.",
  };

  var root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";

  function isTrial(item) {
    if (!item) return false;
    var sku = (item.sku || "").toUpperCase();
    if (CONFIG.skuPrefix && sku.indexOf(CONFIG.skuPrefix.toUpperCase()) === 0)
      return true;
    return CONFIG.handles.indexOf(item.handle) !== -1;
  }

  function getCart() {
    return fetch(root + "cart.js", {
      headers: { Accept: "application/json" },
    }).then(function (r) {
      return r.json();
    });
  }

  // Apply one /cart/change.js mutation (by line-item key).
  function changeLine(key, quantity) {
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  // Run mutations one after another so line keys stay valid.
  function applyChanges(changes) {
    return changes.reduce(function (chain, c) {
      return chain.then(function () {
        return changeLine(c.id, c.quantity);
      });
    }, Promise.resolve());
  }

  var running = false;
  var pending = false;

  function enforce() {
    if (running) {
      pending = true;
      return;
    }
    running = true;

    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var trial = items.filter(isTrial);
        if (trial.length === 0) return null; // nothing to police

        // NOTE: RULE 1 (dependency) is currently DISABLED — the trial CAN be
        // ordered on its own, WITHOUT any other product in the cart.
        // The `others` list is only needed by Rule 1, so it is commented out too.
        // var others = items.filter(function (i) { return !isTrial(i); });

        var changes = [];
        var message = "";

        /* ---------------------------------------------------------------------
           RULE 1 (DEPENDENCY) — DISABLED.
           Previously the trial could only be in the cart alongside another
           product, and was auto-removed if left alone. This is now turned OFF,
           so the trial can be bought by itself.

           To RE-ENABLE this rule:
             1. Uncomment the `var others = ...` line above.
             2. Uncomment the `if (others.length === 0) { ... } else {` opener
                below and the matching `}` closer further down.

           if (others.length === 0) {
             // trial alone: remove every trial line.
             trial.forEach(function (l) { changes.push({ id: l.key, quantity: 0 }); });
             message = CONFIG.messageNeedsOther;
           } else {
        --------------------------------------------------------------------- */

        // RULE 2 (SINGLE ITEM) — ALWAYS ENFORCED: keep only the first trial
        // line at quantity 1 (blocks a 2nd flavour, and caps quantity at 1).
        trial.forEach(function (l, idx) {
          if (idx === 0) {
            if (l.quantity > 1) changes.push({ id: l.key, quantity: 1 });
          } else {
            changes.push({ id: l.key, quantity: 0 });
          }
        });
        if (changes.length) message = CONFIG.messageOnlyOne;

        /* } <-- end of the RULE 1 `else` (uncomment when re-enabling Rule 1) */

        if (changes.length === 0) return null;

        return applyChanges(changes).then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          showToast(message);
        });
      })
      .catch(function (e) {
        if (window.console) console.warn("[trial-cart-rules]", e);
      })
      .then(function () {
        running = false;
        if (pending) {
          pending = false;
          enforce();
        }
      });
  }

  // Debounce rapid cart:change bursts into a single pass.
  var debounceTimer = null;
  function scheduleEnforce() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(enforce, 150);
  }

  // --- minimal, self-contained toast -----------------------------------------
  var toastEl = null;
  var toastTimer = null;
  function showToast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.setAttribute("role", "status");
      toastEl.style.cssText = [
        "position:fixed",
        "left:50%",
        "bottom:24px",
        "transform:translateX(-50%)",
        "z-index:2147483647",
        "max-width:min(92vw,420px)",
        "padding:12px 16px",
        "background:#111",
        "color:#fff",
        "border-radius:8px",
        "font-size:14px",
        "line-height:1.4",
        "text-align:center",
        "box-shadow:0 6px 24px rgba(0,0,0,.25)",
        "opacity:0",
        "transition:opacity .2s ease",
        "pointer-events:none",
      ].join(";");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () {
      toastEl.style.opacity = "1";
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.style.opacity = "0";
    }, 4000);
  }

  // --- wire up ---------------------------------------------------------------
  // The theme fires cart:change on adds and line-item quantity/remove actions.
  document.addEventListener("cart:change", scheduleEnforce);

  // Also check once on load, in case the cart is already in a bad state.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enforce);
  } else {
    enforce();
  }
})();
